import { Controller } from "stimulus";
// TODO split logics into different controllers in order to avoid complicated/multi-purpose controllers
export default class extends Controller {
  static targets = ["input"];


  postRepartition(event) {
    let ean = this.inputTarget.value;
    if (ean) {
      ean = ean.padStart(13, '0')
    }
    const formData = new FormData();
    formData.append("ean", ean);
    fetch(this.inputTarget.dataset.url, {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.received_product_id) {
          const row = document.querySelector(`#buyer-purchase-line-${data.received_product_id}`);
          const list = document.querySelector('#buyer-purchase-lines-list')
          if (row && list) {
            list.prepend(row); // Déplace l'élément en haut de la liste
          }

        }
      })
  }

}
